import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { PatientNotesDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { PatientNoteDto } from 'src/app/shared/models/patient/patient-note-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class PatientNoteWorkItem extends WorkItem<PatientNoteDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'PatientNoteWorkItem';
  }
  get database(): string {
    return PatientNotesDB;
  }
}
